import { emptyNormalized, type NormalizedImport, type NormalizedTask } from '../normalizedImport';

// Trello JSON board export.
export function parseTrelloJSON(jsonText: string): NormalizedImport {
  const out = emptyNormalized('trello');
  let board: any;
  try { board = JSON.parse(jsonText); } catch (e) {
    out.warnings.push('Trello export is not valid JSON');
    return out;
  }
  const projectExternalId = `trello:${board.id ?? 'board'}`;
  out.projects.push({ externalId: projectExternalId, name: board.name ?? 'Trello board' });

  const memberMap = new Map<string, string>();
  for (const m of board.members ?? []) {
    const id = `assignee:trello:${m.id}`;
    memberMap.set(m.id, id);
    out.assignees.push({ externalId: id, name: m.fullName ?? m.username ?? 'Member' });
  }

  const listMap = new Map<string, string>(); // listId -> name (used as raw status)
  for (const l of board.lists ?? []) listMap.set(l.id, l.name);

  for (const card of board.cards ?? []) {
    if (card.closed) continue;
    const t: NormalizedTask = {
      externalId: `trello:card:${card.id}`,
      name: card.name ?? 'Untitled card',
      intent: card.desc || undefined,
      status: listMap.get(card.idList),
      endDate: card.due || undefined,
      assigneeExternalIds: (card.idMembers ?? []).map((id: string) => memberMap.get(id)).filter(Boolean),
      tags: (card.labels ?? []).map((l: any) => l.name).filter(Boolean),
      attachments: (card.attachments ?? []).map((a: any) => ({ url: a.url, name: a.name })),
    };
    out.tasks.push(t);
  }

  return out;
}
